import EarningDeduction from './EarningDeduction.vue';

export default EarningDeduction;